import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Categories2.css";

const Categories2 = () => {
  const [category2Data, setCategory2Data] = useState([]);
  const headerRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        if (response.data && Array.isArray(response.data.row)) {
          setCategory2Data(response.data.row);
        } else {
          setCategory2Data([]);
        }
      } catch (error) {
        console.error("Category fetch error:", error);
        setCategory2Data([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.15 }
    );

    if (headerRef.current) observer.observe(headerRef.current);
    itemRefs.current.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, [category2Data]);

  return (
    <nav className="category2-nav">
      <div className="category2-header" ref={headerRef}>
        <h2 className="category2-title">Trending Categories</h2>
      </div>

      <div className="category2-container">
        <div className="category2-list">
          {category2Data.map((category, index) => (
            <Link
              to={`/subcategory/${category.category_id}`}
              className="category2-link"
              key={category.category_id}
              ref={(el) => (itemRefs.current[index] = el)}
              style={{ "--delay": `${index * 60}ms` }}
            >
              <div className="category2-item">
                <div className="category2-iconBox">
                  <img
                    src={`https://cyberathon.com/multivendor/${category.image}`}
                    alt={category.category_name}
                    className="category2-image"
                  />
                </div>
                <span className="category2-name">{category.category_name}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Categories2;